import { Currency, CurrencyAmount, ETHER, Token, TokenAmount } from '@uniswap/sdk'
import { WETH_EXTENDED, SupportedChainId } from '../constants'

export function wrappedCurrency(
  currency: Currency | undefined,
  chainId: SupportedChainId | undefined
): Token | undefined {
  return chainId && currency === ETHER ? WETH_EXTENDED[chainId] : currency instanceof Token ? currency : undefined
}

export function wrappedCurrencyAmount(
  currencyAmount: CurrencyAmount | undefined,
  chainId: SupportedChainId | undefined
): TokenAmount | undefined {
  const token = currencyAmount && chainId ? wrappedCurrency(currencyAmount.currency, chainId) : undefined
  return token && currencyAmount ? new TokenAmount(token, currencyAmount.raw) : undefined
}

export function unwrappedToken(token: Token): Currency {
  const weth = WETH_EXTENDED[token.chainId as SupportedChainId]
  if (weth && token.equals(weth)) return ETHER
  return token
}
